import { render, staticRenderFns } from "./LayoutToggles.vue?vue&type=template&id=63e3ec2a&scoped=true"
import script from "./LayoutToggles.vue?vue&type=script&lang=js"
export * from "./LayoutToggles.vue?vue&type=script&lang=js"
import style0 from "./LayoutToggles.vue?vue&type=style&index=0&id=63e3ec2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e3ec2a",
  null
  
)

export default component.exports